import { useCallback, useState } from "react";
import { authenticate } from "../api";

export type AuthStatus = "idle" | "loading" | "success" | "error";

export interface AuthResult {
  clientId: string;
}

// Manages login state and calls the backend auth endpoint.
export function useAuth() {
  const [status, setStatus] = useState<AuthStatus>("idle");
  const [error, setError] = useState<string | null>(null);

  const login = useCallback(
    async (username: string, password: string): Promise<AuthResult | null> => {
      setStatus("loading");
      setError(null);
      try {
        const { clientId } = await authenticate(username, password);
        setStatus("success");
        return { clientId };
      } catch (e) {
        setStatus("error");
        setError(e instanceof Error ? e.message : "Sign in failed.");
        return null;
      }
    },
    [],
  );

  return { status, error, login };
}
